import axios from 'axios'
import config from '../config'
import {getDoctorToken} from '../utils'

const saveArticleLikeApi = async (params) => {
    console.log("params",params)
    const response = await axios({
        url: `${config.api.base_url}article/like`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default saveArticleLikeApi